var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.currentStep !== 4
        ? _c("progress-bar", {
            key: _vm.currentStep + " " + _vm.currentSubStep,
            staticClass: "mt-1 p-1",
            attrs: {
              steps: _vm.steps,
              "current-step": _vm.currentStep,
              "current-sub-step": _vm.currentSubStep,
            },
            on: { click: _vm.progressBarClick },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasError
        ? _c("AlertMessage", {
            attrs: { title: _vm.messages.error, type: "danger" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-2" },
        [
          _vm.currentStep === 1
            ? [
                !_vm.selectedCategory
                  ? [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.messages.step1Title),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "categories-wrapper" }, [
                        _c(
                          "button",
                          {
                            staticClass: "ob1-card category",
                            on: {
                              click: function ($event) {
                                return _vm.selectCategory("mobile")
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "lead d-block",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.messages.categories.mobile.label
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "pb-1",
                              attrs: {
                                src: _vm.messages.categories.mobile.imgPath,
                                alt: "",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "ob1-card category",
                            on: {
                              click: function ($event) {
                                return _vm.selectCategory("tablette")
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "lead d-block",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.messages.categories.tablet.label
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "pb-1",
                              attrs: {
                                src: _vm.messages.categories.tablet.imgPath,
                                alt: "",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "ob1-card category",
                            on: {
                              click: function ($event) {
                                return _vm.selectCategory("objets")
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "lead d-block",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.messages.categories.connectedObject.label
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "pb-1",
                              attrs: {
                                src: _vm.messages.categories.connectedObject
                                  .imgPath,
                                alt: "",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "ob1-card category",
                            on: {
                              click: function ($event) {
                                return _vm.selectCategory("imei")
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "lead d-block",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.messages.categories.imei.label
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "pb-1",
                              attrs: {
                                src: _vm.messages.categories.imei.imgPath,
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedCategory
                  ? [
                      _vm.selectedCategory === "mobile"
                        ? _c(
                            "recovery-simulator-selected-category",
                            {
                              attrs: {
                                title: _vm.messages.categories.mobile.label,
                                image: _vm.messages.categories.mobile.imgPath,
                                "back-link-label":
                                  _vm.messages.categories.backLabel,
                              },
                              on: { back: _vm.resetToFirstStep },
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.messages.categories.mobile.description
                                  ),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedCategory === "tablette"
                        ? _c(
                            "recovery-simulator-selected-category",
                            {
                              attrs: {
                                title: _vm.messages.categories.tablet.label,
                                image: _vm.messages.categories.tablet.imgPath,
                                "back-link-label":
                                  _vm.messages.categories.backLabel,
                              },
                              on: { back: _vm.resetToFirstStep },
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.messages.categories.tablet.description
                                  ),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedCategory === "objets"
                        ? _c(
                            "recovery-simulator-selected-category",
                            {
                              attrs: {
                                title:
                                  _vm.messages.categories.connectedObject.label,
                                image:
                                  _vm.messages.categories.connectedObject
                                    .imgPath,
                                "back-link-label":
                                  _vm.messages.categories.backLabel,
                              },
                              on: { back: _vm.resetToFirstStep },
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.messages.categories.connectedObject
                                      .description
                                  ),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedCategory === "imei"
                        ? _c(
                            "recovery-simulator-selected-category",
                            {
                              attrs: {
                                title: _vm.messages.categories.imei.label,
                                image: _vm.messages.categories.imei.imgPath,
                                "back-link-label":
                                  _vm.messages.categories.backLabel,
                              },
                              on: { back: _vm.resetToFirstStep },
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.messages.categories.imei.description
                                  ),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedCategory === "imei"
                        ? [
                            _c("p", { staticClass: "lead mt-2 mb-0" }, [
                              _c("strong", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.messages.searchImei),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("recovery-simulator-by-imei", {
                              attrs: { shop: _vm.shop, messages: _vm.messages },
                              on: {
                                selectModel: _vm.onSelectModel,
                                error: _vm.onError,
                              },
                            }),
                          ]
                        : [
                            _c("p", { staticClass: "lead mt-2 mb-0" }, [
                              _c("strong", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.messages.searchBrand),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("recovery-simulator-by-brand", {
                              attrs: {
                                shop: _vm.shop,
                                category: _vm.selectedCategory,
                                messages: _vm.messages,
                              },
                              on: {
                                selectModel: _vm.onSelectModel,
                                error: _vm.onError,
                              },
                            }),
                          ],
                    ]
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.currentStep === 2
            ? [
                _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.messages.step2Title) },
                }),
                _vm._v(" "),
                _c(
                  "fieldset",
                  [
                    _c("legend", {
                      staticClass: "h4",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.messages.questions.question1Label
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.messages.questions.question1Description
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("recovery-simulator-question-radio", {
                      key: "question1",
                      attrs: { id: "question1", name: "question1" },
                      model: {
                        value: _vm.answer1,
                        callback: function ($$v) {
                          _vm.answer1 = $$v
                        },
                        expression: "answer1",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "fieldset",
                  [
                    _c("legend", {
                      staticClass: "h4",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.messages.questions.question2Label
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.messages.questions.question2Description
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("recovery-simulator-question-radio", {
                      key: "question2",
                      attrs: { id: "question2", name: "question2" },
                      model: {
                        value: _vm.answer2,
                        callback: function ($$v) {
                          _vm.answer2 = $$v
                        },
                        expression: "answer2",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.currentStep === 3
            ? [
                _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.messages.step3Title) },
                }),
                _vm._v(" "),
                _c(
                  "fieldset",
                  [
                    _c("legend", {
                      staticClass: "h4",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.messages.questions.question3Label
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.messages.questions.question3Description
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("recovery-simulator-question-radio", {
                      key: "question3",
                      attrs: { id: "question3", name: "question3" },
                      model: {
                        value: _vm.answer3,
                        callback: function ($$v) {
                          _vm.answer3 = $$v
                        },
                        expression: "answer3",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", {
                  staticClass: "h4",
                  domProps: {
                    innerHTML: _vm._s(_vm.messages.questions.question4Label),
                  },
                }),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.messages.questions.question4Description
                    ),
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bg-white pb-1", attrs: { id: "continue-button" } },
        [
          _c("hr", {
            staticClass: "separator separator--gray4 mb-1 d-md-none",
          }),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.flexJustify, attrs: { id: "buttons-container" } },
            [
              _vm.currentStep > 1
                ? _c("Lien", {
                    attrs: {
                      label: _vm.messages.backButtonLabel,
                      "is-link-arrow-back": "",
                      "is-mini": "",
                      "is-button": "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.goToPreviousStep()
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("button", {
                staticClass: "d-block btn btn-primary",
                attrs: {
                  type: "button",
                  href: "#",
                  disabled: !_vm.buttonEnabled,
                },
                domProps: { innerHTML: _vm._s(_vm.buttonLabel) },
                on: {
                  click: function ($event) {
                    return _vm.goToNextStep()
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }